import React from 'react';
import Link from '../Link/Link';
var CardIcon = function (props) {
    var _a = props.type, type = _a === void 0 ? 'default' : _a, _b = props.iconClass, iconClass = _b === void 0 ? '' : _b, _c = props.to, to = _c === void 0 ? '/' : _c, _d = props.href, href = _d === void 0 ? '#' : _d, target = props.target, _e = props.narrow, narrow = _e === void 0 ? true : _e, _f = props.title, title = _f === void 0 ? '' : _f, _g = props.subTitle, subTitle = _g === void 0 ? '' : _g;
    var createCardClass = function () {
        var classNames = 'card card-dnvgl';
        if (narrow)
            classNames += ' card-narrow';
        if (isLink())
            classNames += ' card-anchor';
        classNames += ' card-icon';
        return classNames;
    };
    var isLink = function () { return type === 'link'; };
    var renderLink = function () {
        return to !== null ? (React.createElement(Link, { className: createCardClass(), to: to, target: target }, renderContent())) : (React.createElement("a", { className: createCardClass(), href: href, target: target }, renderContent()));
    };
    var renderContent = function () { return (React.createElement("div", null,
        React.createElement("div", { className: "icon-wrap" },
            React.createElement("i", { className: iconClass })),
        React.createElement("div", { className: "card-body" },
            React.createElement("div", { className: "card-title" }, title),
            subTitle && React.createElement("div", { className: "card-subtitle" }, subTitle)))); };
    return isLink() ? (renderLink()) : (React.createElement("div", { className: createCardClass() }, renderContent()));
};
export default React.memo(CardIcon);
